<template>
  <v-container>
    <v-row justify="center" class="mt-n7">
      <v-col cols="12" md="12">
        <v-row justify="start" align="center" class="mb-3 mx-0">
          <v-btn small @click="beforeRoute" color="primary" outlined>
            <v-icon>keyboard_backspace</v-icon> Volver
          </v-btn>
          <span class="ml-4 text-body-2 grey--text text--darken-2">
            <v-icon small class="mr-1">mdi-printer-outline</v-icon>
            {{ ids.length }} factura{{ ids.length === 1 ? "" : "s" }}
          </span>
          <v-spacer></v-spacer>
          <span class="text-caption grey--text text--darken-1 mr-2">Ordenar por</span>
          <v-btn-toggle v-model="orderBy" mandatory dense color="primary" class="rounded-lg">
            <v-tooltip bottom v-for="option in orderOptions" :key="option.value">
              <template v-slot:activator="{ on, attrs }">
                <v-btn :value="option.value" :disabled="loading" small class="text-none" v-bind="attrs" v-on="on">
                  <v-icon left small>{{ option.icon }}</v-icon>
                  {{ option.text }}
                </v-btn>
              </template>
              <span>{{ option.hint }}</span>
            </v-tooltip>
          </v-btn-toggle>
        </v-row>
        <v-row v-if="!loading">
          <iframe v-if="pdfUrl" style="min-height: 90vh; width: 100%; position: relative" :src="pdfUrl"
            frameborder="0" allowfullscreen></iframe>
          <v-col v-else cols="12" class="text-center grey--text py-10">
            <v-icon size="60" color="grey lighten-1">mdi-file-alert-outline</v-icon>
            <div class="mt-2">{{ errorMessage || "No hay facturas para imprimir" }}</div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <div class="text-center text-body-2 grey--text mb-2">
              Generando {{ ids.length }} factura{{ ids.length === 1 ? "" : "s" }}...
            </div>
            <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image, image, actions"
              height="100vh"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const ORDER_STORAGE_KEY = "invoice_batch_print_order";
const ORDER_OPTIONS = [
  { value: "date", text: "Fecha", icon: "mdi-calendar", hint: "Fecha de emisión" },
  { value: "number", text: "Código", icon: "mdi-pound", hint: "Código de factura (agrupa por ubicación)" },
  { value: "customer", text: "Cliente", icon: "mdi-account", hint: "Cliente, luego fecha" },
  { value: "selection", text: "Selección", icon: "mdi-cursor-default-click", hint: "Orden en que se seleccionaron" },
];

export default {
  data: () => ({
    loading: false,
    pdfUrl: null,
    errorMessage: "",
    orderBy: ORDER_OPTIONS.some((o) => o.value === localStorage.getItem(ORDER_STORAGE_KEY))
      ? localStorage.getItem(ORDER_STORAGE_KEY)
      : "date",
    orderOptions: ORDER_OPTIONS,
  }),
  computed: {
    ids() {
      return String(this.$route.query.ids || "")
        .split(",")
        .map(Number)
        .filter((id) => Number.isInteger(id) && id > 0);
    },
  },
  watch: {
    orderBy(value) {
      localStorage.setItem(ORDER_STORAGE_KEY, value);
      this.getData();
    },
  },
  created() {
    this.getData();
  },
  beforeDestroy() {
    this.revokePdf();
  },
  methods: {
    revokePdf() {
      if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);
      this.pdfUrl = null;
    },
    async getData() {
      this.revokePdf();
      this.errorMessage = "";
      if (this.ids.length === 0) return;

      this.loading = true;
      try {
        const response = await this.api_Post("income/view_invoices_batch", {
          ids: this.ids,
          order_by: this.orderBy,
        });
        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.error || `Error ${response.status}`);
        }
        const blob = await response.blob();
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (error) {
        this.errorMessage = error.message;
        this.$toast.error(`No se pudo generar la impresión: ${error.message}`);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
